import { FC, PropsWithChildren, useMemo } from 'react';
import { faFilterList } from '@fortawesome/pro-regular-svg-icons';
import { Button } from 'framework/button';

import { EMPTY_FUNCTION } from '../../../constants';
import { FiltersContext, useFiltersContext } from '../context/FiltersContext';

import { FiltersOverlayProps } from './types';

const FiltersButton = ({ onClick = EMPTY_FUNCTION, children }: FiltersOverlayProps) => {
  const { filters } = useFiltersContext();

  const count = useMemo(() => {
    if (!filters) return 0;

    return Object.entries(filters).reduce((total, [_, value]) => {
      if (Array.isArray(value)) {
        return total + value.length;
      }

      return total + (value ? 1 : 0);
    }, 0);
  }, [filters]);

  const label = `Filters${count ? ` (${count})` : ''}`;

  return (
    <>
      <Button
        left_icon={faFilterList}
        variant="secondary"
        onClick={onClick}
        height="32px"
        width="fit-content"
      >
        {label}
      </Button>
      {children}
    </>
  );
};

export const Filters: FC<PropsWithChildren<FiltersOverlayProps>> = ({ children, ...rest }) => {
  return (
    <FiltersContext>
      <FiltersButton {...rest}>{children}</FiltersButton>
    </FiltersContext>
  );
};
